import styled from "styled-components";

import { BiSupport } from "react-icons/bi";
import { BsQuestionCircle } from "react-icons/bs";
import { RiRefund2Line } from "react-icons/ri";

const Support = () => {
  return (
    <>
      <Container>
        <div>
          <span>
            {" "}
            <BiSupport />
          </span>
          <div>
            <h4> درخواست پشتیبانی</h4>
            <p>سریع‌ترین راه برای بررسی مشکلات شما</p>
            <a>درخواست پشتیبانی</a>
          </div>
        </div>

        <div>
          <span>
            {" "}
            <BsQuestionCircle />
          </span>
          <div>
            <h4>مشاوره و راهنما</h4>
            <p>راهنمای خرید و استرداد، قوانین و پرسش‌ها</p>
            <a>پشتیبانی آنلاین</a>
          </div>
        </div>

        <div>
          <span>
            {" "}
            <RiRefund2Line />
          </span>
          <div>
            <h4>درخواست استرداد</h4>
            <p>سریع‌ترین راه برای کنسلی و لغو رزرو</p>
            <a>لیست سفر های رزرو شده</a>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Support;

const Container = styled.div`
  width: 1120px;
  height: 200px;
  border-radius: 15px;
  background-color: #ffff;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid rgba(0, 0, 0, 0.1);
  box-shadow: 3px 6px 13px -10px rgba(0, 0, 0, 0.55);
  margin-top: 35px;
  display: flex;
  justify-content: space-around;
  align-items: center;

  @media (max-width: 900px) {
    width: 90vw;
    flex-direction: column;
    height: auto;
    padding: 10px 0;
    margin-top: 5px;
  }

  @media (min-width: 900px) and (max-width: 1120px) {
    width: 98vw;
  }

  div {
    display: flex;
    flex-direction: column;
    direction: rtl;
    text-align: center;

    @media (max-width: 900px) {
      width: 100%;
      flex-direction: row;
      justify-content: space-between;
      padding-right: 10px;
      margin-top: 10px;

      div {
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        padding-right: 15px;

        a {
          margin: 0;
        }
      }
    }

    span {
      display: inline-block;
      margin-left: auto;
      margin-right: auto;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #f6a392;
      color: #e73511;
      text-align: center;
      font-size: 24px;

      svg {
        vertical-align: middle;
      }
    }

    h4 {
      font-size: 20px;
      font-weight: 700;
      color: rgba(0, 0, 0, 0.7);

      @media (max-width: 900px) {
        font-size: 17px;
      }
    }

    p {
      font-size: 16px;
      font-weight: 400;
      color: rgba(0, 0, 0, 0.55);

      @media (max-width: 900px) {
        font-size: 14px;
      }
    }

    a {
      display: inline-block;
      color: #2743f5;
      max-width: 200px;
      margin: auto;
      cursor: pointer;

      &:hover {
        background-color: #8d9dfa42;
        border-color: #4a61f7;
        padding: 0 10px;
        border-radius: 5px;
      }
    }
  }
`;
